'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cleanProps = require('./clean-props');

var _cleanProps2 = _interopRequireDefault(_cleanProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tag = function Tag(tag) {
  var Base = function Base(props) {
    var isEl = typeof tag === 'string';
    var Comp = isEl ? props.is || tag : tag;
    var next = isEl ? (0, _cleanProps2.default)(props) : props;

    if (isEl) next.is = null;

    return _react2.default.createElement(Comp, next);
  };

  return Base;
};

exports.default = Tag;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Tag.js
// module id = 579
// module chunks = 0